import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private requestCount = 0;
    loading$ = this.loadingSubject.asObservable();

    setLoadingState(isLoading: boolean) {
        this.requestCount = isLoading ? this.requestCount + 1 : this.requestCount - 1;
        this.loadingSubject.next(this.requestCount > 0);
    }
}